import { useReportsContext } from "../../contexts/reports-context";
import { CopilotButton } from "../co-pilot-button";
/* Prop Types */
interface CopilotTileProps {
  metric: string;
}

/*
 * CopilotTile component
 *
 * This component displays a tile that prompts the user to open the Copilot panel for assistance
 *  inside the in-depth report view.
 */
export const CopilotTile = ({ metric }: CopilotTileProps) => {
  /* Context */
  const {
    state: { showCopilot },
    actions: { setShowCopilot },
  } = useReportsContext();

  // display the metric as title case for the copilot panel
  const displayMetric = metric.charAt(0).toUpperCase() + metric.slice(1);

  /* Render */
  return (
    <div className="p-4 rounded-lg flex flex-row gap-3 my-4 bg-base-200 relative overflow-hidden">
      <div className="absolute inset-0 pointer-events-none copilot-bg-animation" />
      <div className="relative z-10">
        <p className="text-sm">
          How to improve <span className="font-semibold">{displayMetric}</span> score?
        </p>
        <p className="text-sm text-base-content/70">Consult our AI-powered Copilot assistant</p>
      </div>
      <CopilotButton className="ml-auto" showChevron onClick={() => setShowCopilot(!showCopilot)} />
    </div>
  );
};
